import { NotificationTypeEnum } from 'Components/designSystem';
import { WelcomeBanner } from 'features/navigation';
import { showToast } from 'modules/ToastManager';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ApiError, ErrorCode } from 'shared/api';
import { ContentCard, PageLayout } from 'shared/components';
import { APP_ROUTES } from 'shared/constants';
import { useAccessFilterCheck, useAppDispatch, useSendMessage } from 'shared/hooks';

import { AskForOpportunitiesForm } from '../components';

const SUCCESS_NOTIFICATION_DURATION = 5000;

export default function AskForOpportunities() {
    const { t } = useTranslation('askForOpportunities');
    const jobPreferencesEnabled = useAccessFilterCheck({ feature: 'CandidatesJobPreferences' });
    const navigate = useNavigate();
    const { search } = useLocation();
    const dispatch = useAppDispatch();
    const [ errorCode, setErrorCode ] = useState<ErrorCode | undefined>();

    const goBack = useCallback(() => {
        navigate({
            pathname: APP_ROUTES.candidateOffers,
            search
        });
    }, [ navigate, search ]);

    const { mutate: sendOpportunitiesRequest, isPending } = useSendMessage({
        onSuccess: () => {
            dispatch(showToast({
                toast: {
                    id: 'askForOpportunities',
                    type: NotificationTypeEnum.Success,
                    description: t('successToastText'),
                    duration: SUCCESS_NOTIFICATION_DURATION
                }
            }));
            goBack();
        },
        onError: (error) => {
            if (error instanceof ApiError) {
                setErrorCode(error.errorCode);
            }
        }
    });

    const handleSubmit = useCallback((freeText: string) => {
        setErrorCode(undefined);
        sendOpportunitiesRequest({
            type: 'OpportunitiesRequest',
            payload: { freeText }
        });
    }, [ sendOpportunitiesRequest ]);

    useEffect(() => {
        if (jobPreferencesEnabled) {
            navigate({
                pathname: APP_ROUTES.candidateOffers,
                search
            });
        }
    }, [ jobPreferencesEnabled, navigate, search ]);

    return (
        <>
            <WelcomeBanner pageType="requestForOpportunities" />

            <PageLayout>
                <ContentCard contentMaxWidth="lg">
                    <AskForOpportunitiesForm onSubmit={ handleSubmit }
                        isLoading={ isPending }
                        errorCode={ errorCode }
                    />
                </ContentCard>
            </PageLayout>
        </>
    );
}
